<template>
  <div>
    <div class="d-flex align-center">
      <div
        :style="squareStyle"
        class="legend-item-square mr-2"
        :class="color"
      ></div>
      <div class="flex-grow-1 text-body-1 black--text">
        {{ label }}
      </div>

      <count-badge v-if="showCount" :count="count" />
    </div>
  </div>
</template>

<script>
import CountBadge from '@/components/Common/CountBadge';

export default {
  name: 'ScreeningProgressLegendItem',
  components: { CountBadge },
  props: {
    color: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    squareSize: {
      type: Number,
      default: 14,
    },
    showCount: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    squareStyle() {
      return {
        width: `${this.squareSize}px`,
        height: `${this.squareSize}px`,
      };
    },
  },
};
</script>
